import { render, staticRenderFns } from "./Mantenedor_Pac_Causas.vue?vue&type=template&id=0fc52c14&"
import script from "./Mantenedor_Pac_Causas.vue?vue&type=script&lang=js&"
export * from "./Mantenedor_Pac_Causas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports